import React from 'react'
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  FormControl
} from '@material-ui/core'
import SearchSelect from './SearchSelect'

export default class RouteChickenModal extends React.Component {
  constructor(props) {
    super(props)
		
    this.onDisagree = this.onDisagree.bind(this)
    this.onAgree = this.onAgree.bind(this)
    this.onCrewChange = this.onCrewChange.bind(this)
    this.filterCrews = this.filterCrews.bind(this)
		
    this.state = { selectedCrew: { value: '', label: '' }, crewOptions: [] }
  }
	
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { crews, userVendorID, routeExtraData } = this.props
    const isProdDescDifferent = (routeExtraData && routeExtraData.Prod_CrewDesc) !== (prevProps.routeExtraData && prevProps.routeExtraData.Prod_CrewDesc)
    if (userVendorID !== prevProps.userVendorID || isProdDescDifferent) {
      this.setState({ crewOptions: crews.filter(({ VendorIdd, Prod_CrewDesc, Crew_Active_YN }) => {
        return VendorIdd === userVendorID && Prod_CrewDesc === (routeExtraData && routeExtraData.Prod_CrewDesc) && Crew_Active_YN === true
      }).map(({ CrewID, CrewName }) => ({ label: `${CrewName}`, value: CrewID })) })
    }
  }
	
  onDisagree() {
    const { setVendorOverride } = this.props
    this.setState({ selectedCrew: { value: '', label: '' } })
    setVendorOverride(false)
  }
	
  onAgree() {
    const { selectedCrew: { value } } = this.state
    const { setVendorOverride } = this.props
    this.setState({ selectedCrew: { value: '', label: '' } })
    setVendorOverride(true, value)
  }
	
  onCrewChange(option) {
    const { value, label } = option || {}
    this.setState({ selectedCrew: { label, value } })
  }
	
  filterCrews(search) {
    const { crewOptions } = this.state
    return Promise.resolve(crewOptions.filter(({ label }) => label.toLowerCase().includes(search.toLowerCase())).slice(0, 50))
  }
	
  render() {
    const { showModal, modalProperty, routeVendor, routeExtraData } = this.props
    const { selectedCrew, crewOptions } = this.state

    return (
      <Dialog
        open={showModal}
        onClose={this.onDisagree}
        disableBackdropClick
      >
        <DialogTitle id="alert-dialog-title">Override Route Vendor</DialogTitle>
				
        <DialogContent style={{ height: 500 }}>
          <DialogContentText id="alert-dialog-description">
            {
              `Route: ${modalProperty} is assigned to vendor: ${routeVendor && routeVendor.VendorName}. Are you sure you want to enter a Time Sheet record for this Route?`
            }
          </DialogContentText>
					
          <DialogContentText>
            Select a <span style={{ fontWeight: 'bold' }}>{routeExtraData && routeExtraData.Prod_CrewDesc}</span> crew to override the route
          </DialogContentText>
					
          <FormControl style={{ marginTop: 20, width: '100%' }}>
            <SearchSelect
              label="Crew"
              defaultOptions={crewOptions.slice(0, 50)}
              value={selectedCrew}
              onChange={this.onCrewChange}
              loadOptions={this.filterCrews}
            />
          </FormControl>
        </DialogContent>
				
        <DialogActions>
          <Button onClick={this.onDisagree} color="primary">Cancel</Button>
          <Button onClick={this.onAgree} color="primary" autoFocus disabled={selectedCrew.value === ''}>Apply</Button>
        </DialogActions>
      </Dialog>
    )
  }
}